// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","loader":"loader-portal_loader__nQvtt"};